import { useState } from "react";
import { Plus } from "lucide-react";

const faqs = [
  {
    q: "Do I need to move the rubbish outside first?",
    a: "No. Our team can collect the items from where they are and do the heavy lifting for you, subject to safe and reasonable access.",
  },
  {
    q: "Can I send photos for a quote?",
    a: "Yes. Photos are one of the easiest ways for us to understand the amount and type of rubbish you need removed.",
  },
  {
    q: "Do you remove single items?",
    a: "Yes. We can assist with anything from individual bulky items through to larger clear-outs.",
  },
  {
    q: "Do you provide same-day rubbish removal?",
    a: "Same-day or short-notice pickups may be available depending on the schedule. Contact us to check availability.",
  },
  {
    q: "Do you take furniture and mattresses?",
    a: "Yes. Furniture, mattresses and many other bulky household items can be removed.",
  },
  {
    q: "Can you clear an entire property?",
    a: "Yes. Larger household, rental and commercial clear-outs can be quoted based on the volume, access and type of material involved.",
  },
  {
    q: "What if I'm not sure how much rubbish I have?",
    a: "Send us photos. We'll help estimate the size of the job.",
  },
];

const FaqSection = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-white py-16 md:py-24">
      <div className="container max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-12">
          Frequently Asked Questions
        </h2>
        <div className="divide-y divide-[#1a1a1a]/10 border-y border-[#1a1a1a]/10">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                    className="w-full flex items-center justify-between gap-4 py-5 text-left font-bold text-[#1a1a1a] hover:text-orange-deep transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange/50 rounded"
                  >
                    <span>{f.q}</span>
                    <Plus
                      className={`w-5 h-5 shrink-0 text-orange transition-transform duration-200 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                </h3>
                <div
                  id={`faq-panel-${i}`}
                  hidden={!isOpen}
                  className="pb-5 -mt-1 text-[#1a1a1a]/70 leading-relaxed"
                >
                  {f.a}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
